import { isSubflowCardNode } from "@/components/SpotflowV2/Sidebar/invokeSubflowBindings";
import { isAgentSubflowNodeType } from "@/utils/nodePickerUtils";

export const DEFAULT_SUBFLOW_ICON = "workflow";
export const DEFAULT_AGENT_ICON = "coworker";

function iconOr(value: unknown, fallback: string): string {
  return typeof value === "string" && value ? value : fallback;
}

export function nodeIconName(
  nodeType: string | undefined,
  nodeConfig: Record<string, unknown> | undefined
): string | undefined {
  if (isSubflowCardNode(nodeType)) {
    return iconOr(nodeConfig?.workflow_icon, DEFAULT_SUBFLOW_ICON);
  }
  if (nodeType && isAgentSubflowNodeType(nodeType)) {
    return iconOr(nodeConfig?.assistant_icon, DEFAULT_AGENT_ICON);
  }
  return undefined;
}
